import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精品推荐
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            编辑部精选，不可错过的动漫内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 cursor-pointer transition-all duration-200"
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 bg-accent-500 text-white text-xs font-semibold rounded-full whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}